import React from "react";

import icon from "./icon.svg";

function SunnyIcon({ className }: { className: string }) {
  return <img className={className} src={icon} alt="Sunny" />;
}

export { SunnyIcon };
